"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const remove_trailing_slash_1 = __importDefault(require("remove-trailing-slash"));
/**
 * Distinct ID endpoint.
 */
const DISTINCT_ID_ENDPOINT = '/api/distinct_id';
/**
 * Make a request to the `/api/distinct_id` endpoint using the
 * provided `params`. Will swallow request/network errors, and
 * _may not_ resolve with any data.
 */
const request = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const url = (0, remove_trailing_slash_1.default)(params.host) + DISTINCT_ID_ENDPOINT;
    const headers = {
        Origin: params.origin
    };
    let body;
    // Set the payload if provided.
    if (params.payload) {
        body = JSON.stringify(params.payload);
        headers['Content-Type'] = 'application/json';
    }
    // Set the access token if provided.
    if (params.token) {
        headers.Authorization = `Bearer ${params.token}`;
    }
    const options = {
        credentials: 'include',
        method: params.method,
        headers,
        body
    };
    try {
        const res = yield fetch(url, options);
        if (!res.ok) {
            return null;
        }
        const data = yield res.json();
        return data;
    }
    catch (_a) {
        // Oh well, we tried.
        return null;
    }
});
exports.default = request;
//# sourceMappingURL=request.js.map